/* eslint-disable no-restricted-globals */
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-prototype-builtins */
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import Bugsnag from '@bugsnag/js';
import { getPortfolio, onDemandSubscription, sendEvents } from '../redux/actions/Home';
import { getBundleCauses, getCauseAmount } from './abVariables';
import CoverImg from '../src/public/images/coverImg.png';
import MultiplecoverImg from '../src/public/images/multiple-child-img.png';
import DOMPurify from 'dompurify';

export const addQuery = (dataObject, apiObject) => {
  if (!dataObject) {
    return '';
  }

  const keys = [
    'orderId',
    'url_id',
    'search',
    's',
    'lat',
    'long',
    'with',
    'group_id',
    'postId',
    'tags',
    'query',
  ];

  keys.map((key) => {
    if (dataObject.hasOwnProperty(key) && typeof dataObject[key] !== 'object') {
      if (apiObject.query.hasOwnProperty(key)) {
        // eslint-disable-next-line no-param-reassign
        apiObject.addQuery = { key, payload: dataObject[key] };
      }
    } else {
      dataObject[key]
        && Object.keys(dataObject[key]).map((keyName) => {
          if (apiObject.query.hasOwnProperty(keyName)) {
            // eslint-disable-next-line no-param-reassign
            apiObject.addQuery = {
              key: keyName,
              payload: dataObject[key][keyName],
            };
          }
        });
    }
  });
  return false;
};

export const generateQuery = (query) => {
  let url = '';

  if (query.hasOwnProperty('url_id')) {
    url = `/${query.url_id}`;
  }

  const newUrl = url
    + Object.keys(query).reduce((accumulator, key, index) => {
      if (query[key] == '' || query[key] == null || key == 'url_id') {
        return accumulator;
      }

      return `${accumulator}${index != 0 ? '&' : '?'}${key}=${query[key]}`;
    }, '');

  return newUrl;
};

export const AuthToken = () => {
  try {
    const tokens = localStorage.getItem('AuthToken');

    if (tokens !== undefined) {
      return tokens;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const objectLength = (obj) => Object.keys(obj).length;

export const validateEmail = (emailField) => {
  const reg = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return reg.test(emailField);
};

export const getCurrencySymbol = (currency) => {
  const currencySymbol = {
    AED: 'AED',
    USD: '$', // US Dollar
    EUR: '€', // Euro
    CRC: '₡', // Costa Rican Colón
    GBP: '£', // British Pound Sterling
    ILS: '₪', // Israeli New Sheqel
    INR: '₹', // Indian Rupee
    JPY: '¥', // Japanese Yen
    KRW: '₩', // South Korean Won
    NGN: '₦', // Nigerian Naira
    PHP: '₱', // Philippine Peso
    PLN: 'zł', // Polish Zloty
    PYG: '₲', // Paraguayan Guarani
    THB: '฿', // Thai Baht
    UAH: '₴', // Ukrainian Hryvnia
    VND: '₫', // Vietnamese Dong
    SAR: 'SAR', // South african rand
    SGD: 'SGD', // Vietnamese Dong
    CAD: 'CAD',
    HKD: 'HKD',
    QAR: 'QAR',
    AUD: 'AUD',
    MYR: 'MYR',
  };

  if (currency && currencySymbol[currency.toUpperCase()] !== undefined) {
    return currencySymbol[currency.toUpperCase()];
  }
  return false;
};

export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

export const handlePledgeMoreLink = (amount, newAmount, source = '', email, cause) => {
  const slab = window.pledgeMoreSlab;
  let url = null;
  if (getCookie('platform').toLowerCase() === 'ios') {
    url = handleKettoLinks(`new/login?em=${email}&to=new/pledge-more&pr=pledge&amt=${newAmount}&pledgeAmt=${amount}&src=${source}${slab ? `&slab=${slab}` : ''}&sip_cause=${cause}&pledge_more=1`); // Get full url according to env
  } else {
    url = handleKettoLinks(`new/pledge-more?pr=pledge&amt=${newAmount}&pledgeAmt=${amount}&src=${source}${slab ? `&slab=${slab}` : ''}&sip_cause=${cause}&pledge_more=1`);
  }
  if (cause == 'animals') {
    blitzTrigger('Animal Pledge');
  }

  window.open(url, '_blank');
};

export const getCookie = (cname) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const isMobile = () => navigator && navigator.userAgentData && navigator.userAgentData.mobile;

export const handleScrollIntoSection = (focusParams) => {
  const elem = document.getElementById(focusParams);
  if (focusParams !== 'feedback' && elem && 'offsetTop' in elem) {
    window.scrollTo(0, elem.offsetTop);
  } else if (focusParams === 'feedback') {
    window.scrollTo(0, document.body.scrollHeight + 4000);
  }
};

export const handleSocialMedia = (type, action, cardType = '', sipCardtype = '', page = 'home', donateShare = '') => {
  if (action === 'chat') {
    if (type === 'facebook') {
      window.open('https://www.facebook.com/profile.php?id=100064806753864', '_blank');
    } else {
      window.open('https://api.whatsapp.com/send?phone=919930088522', '_blank');
    }
  } else if (action === 'share') {
    const userData = JSON.parse(localStorage.getItem('userdata'));
    const whatsAppDomain = isMobile() ? 'api' : 'web';
    const medium = type === 'facebook' ? 'facebook_share' : 'whatsapp_share';
    let url = null;
    let message = null;
    let domain = null;
    const info_3 = !checkNonSip(userData?.listsubscriptions) ? 'impact' : 'nonSip_to_sip';
    if (!donateShare && !donateShare.url && !donateShare.msg) {
      const name = userData.full_name ? userData.full_name : '';
      const lives = userData.aggdonationall ? userData.aggdonationall.campaigns : '';
      url = handleKettoLinks(`new/referral?utm_medium=${medium}&utm_content=${userData.id}&shby=1&utm_source=internal&name=${name}&lives=${lives}`);
      message = `I am delighted to become a part of Ketto’s Social Impact Plan! You can join me too in helping those in need get a second chance at life! Learn more here: ${url}`;
      domain = type === 'facebook' ? `https://www.facebook.com/sharer/sharer.php?&u=${url}&quote=I am delighted to become a part of Ketto’s Social Impact Plan! You can join me too in helping those in need get a second chance at life! Learn more here: ${url}` : `https://${whatsAppDomain}.whatsapp.com/send?text=${message}`;

      if (cardType === 'card1' && type === 'facebook') {
        sendEvents('fb_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'monthly_donors', info_3, '', true);
      } else if (cardType === 'card2' && type === 'facebook') {
        sendEvents('fb_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'kids_impact', info_3, '', true);
      } else if (cardType === 'card3' && type === 'facebook') {
        sendEvents('fb_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'contributed', info_3, '', true);
      } else if (cardType === 'card4' && type === 'facebook') {
        sendEvents('fb_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'proud_changemakers', info_3, '', true);
      } else if (cardType === 'card1' && type === 'whatsapp') {
        sendEvents('whatsapp_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'monthly_donors', info_3, '', true);
      } else if (cardType === 'card2' && type === 'whatsapp') {
        sendEvents('whatsapp_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'kids_impact', info_3, '', true);
      } else if (cardType === 'card3' && type === 'whatsapp') {
        sendEvents('whatsapp_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'contributed', info_3, '', true);
      } else if (cardType === 'card4' && type === 'whatsapp') {
        sendEvents('whatsapp_share', page == 'home' ? 'sip_returning_homepage' : 'sip_returning', 'proud_changemakers', info_3, '', true);
      }

      if (sipCardtype === 'invite_a_friend') {
        type === 'facebook' ? sendEvents('fb_share', 'sip_returning', 'activity', info_3, 'invite_a_friend_cta', true) : sendEvents('whatsapp_share', 'sip_returning', 'activity', info_3, 'invite_a_friend_cta', true);
      }

      if (sipCardtype === 'refer_more_friends') {
        type === 'facebook' ? sendEvents('fb_share', 'sip_returning', 'activity', info_3, 'refer_more_friends_cta', true) : sendEvents('whatsapp_share', 'sip_returning', 'activity', info_3, 'refer_more_friends_cta', true);
      }
    } else {
      url = donateShare.url;
      message = encodeURIComponent(donateShare.msg);
      domain = type === 'facebook' ? `https://www.facebook.com/sharer/sharer.php?&u=${url}` : `https://${whatsAppDomain}.whatsapp.com/send?text=${message}`;
    }
    window.open(domain, '_blank');
  }
};

export const whatsAppShare = (msg) => {
  const message = encodeURIComponent(msg);
  const whatsAppDomain = isMobile() ? 'api' : 'web';
  const domain = `https://${whatsAppDomain}.whatsapp.com/send?text=${message}`;
  window.open(domain, '_blank');
};

export const extractContent = (str) => {
  const span = document.createElement('span');
  span.innerHTML = str;
  return span.textContent || span.innerText;
};

export const zohoSupportScript = () => {
  // window.$zohosq.chatbutton.visible('show');
  window.$zohosq.floatwindow.visible('show');
};

export const checkUserValidity = async () => {
  const cookie = getCookie('u_auth');
  if (!cookie) {
    return false;
  }
  return true;
};

export const handleKettoLinks = (url, fromSignIn = false, ignoreUtm = false) => {
  const checkParam = url && url.includes('?');
  let utmParam = null;
  if (ignoreUtm) {
    utmParam = url
  } else if (fromSignIn) {
    utmParam = url;
  } else if (checkParam && getUTMSource()) {
    utmParam = url + getUTMSource();
  } else if (getUTMSource()) {
    utmParam = url + '?' + getUTMSource()?.slice(1);
  } else {
    utmParam = url;
  }
  utmParam = removeDuplicateParams(utmParam);
  const base = process.env.NODE_ENV == 'development' ? `https://dev5.ketto.org/${utmParam}` : `https://www.ketto.org/${utmParam}`;
  return base;
};

export const handleLinks = (url) => {
  const base = process.env.NODE_ENV == 'development' ? `https://devsip.ketto.org/${url}` : `https://sip.ketto.org/${url}`;
  return base;
};

export const handleLogout = () => {
  localStorage.removeItem('userdata');
  sessionStorage.removeItem('multiCauseId');
  localStorage.removeItem('multiArray');
  localStorage.removeItem('appMultiId');
  localStorage.removeItem('cartCause');
  window.location.href = handleKettoLinks('new/logout');
};

// Return suffixes for index count
export const nth = (d) => {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

// Return comma separated Amount
export const handleRupee = (val) => parseInt(val, 10).toLocaleString('en-IN');

// Get current environment
export const getEnv = () => (process.env.NODE_ENV == 'development' ? 'development' : 'production');

// Get new pledge amount for pledge more
export const getPledgeAmt = (currency, amt) => {
  // const slab = getSlab();
  // let newAmt = null;
  // if (!slab) {
  const newAmt = parseInt(amt) + (parseInt(amt) * 0.33);
  // } else if (slab === 'Slab1') {
  //   newAmt = parseInt(amt) * 3;
  // } else {
  //   newAmt = parseInt(amt) * 5;
  // }

  if (currency == 'INR') {
    return newAmt + (100 - (newAmt % 100 ? newAmt % 100 : 100));
  }
  // USD, EUR, GBP, AED, SAR, SGD
  return newAmt + (10 - (newAmt % 10 ? newAmt % 10 : 10));
};

// Check campaign status
// eslint-disable-next-line no-unused-vars
export const isFundraiserExpired = (status, endDate) => {
  switch (status) {
    // Fundraiser Active
    case 1:
      return false;
    // Fundraiser Expired
    case 4:
      return true;
    // Fundraiser Active
    case 5:
      return false;
    // Fundraiser Active
    case 8:
      return false;
    default:
      return '';
  }
};

// Get encoded cookies
export const getDecodedCookies = (name) => {
  if (typeof document !== 'undefined') {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return JSON.parse(window.atob(decodeURIComponent(parts.pop().split(';').shift())));
    }
    return '';
  }
  return false;
};

// Get parameter values in URL
export const getUrlParams = () => {
  const search = document.location.search.substring(1);
  const extraParams = Object.assign(...search.split('&').map((s) => s.split('=')).map(([k, v]) => ({ [k]: v })));
  Object.keys(extraParams).forEach((k) => extraParams[k] == null && delete extraParams[k]);
  return extraParams;
};

// Logout user and redirect to sign in page
export const handleApiErrors = (errorStatus, errorMsg) => {
  const token = getCookie('u_auth');
  const platform = getCookie('platform');
  const userEmail = JSON.parse(localStorage.getItem('userdata')) || {};
  Bugsnag.notify(new Error(`API Error : status - ${errorMsg} , u_auth-${token} , platform - ${platform ? 'App' : 'Web'},email - ${userEmail?.email} `));
  handleDeleteCookie('u_auth');
  window.location.href = handleKettoLinks('/new/logout?redirect_uri=/new/signin');
};

export const handleDeleteCookie = (name) => {
  document.cookie = `${name}=; Path=/; domain=ketto.org; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export const getUrlParameterByName = (name, url = document.location.href) => {
  // Returns URL paramter values
  name = name?.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
export const getUserData = () => new Promise((resolve, reject) => {
  const data = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')) : '';
  if (data) {
    resolve(data);
  } else {
    reject(new Error('no data'));
  }
});

export const getLocalData = (name) => new Promise((resolve, reject) => {
  const data = localStorage.getItem(name) ? JSON.parse(localStorage.getItem(name)) : '';
  if (data) {
    resolve(data);
  } else {
    reject(new Error('no data'));
  }
});

export const handleReturnDayDiff = (date) => {
  if (date) {
    const givenDate = date.split(' ')[0];
    const diff = dayjs(givenDate).diff(dayjs(new Date()).format('YYYY-MM-DD'), 'days');
    return diff;
  }
  return false;
};

export const handleUserStatus = (value) => {
  if (value == '2') {
    return 'lapsed';
  } if (value == '4') {
    return 'canceled';
  }
  if (value == 5) {
    return 'cReq';
  }
  return false;
};

export const handleReferFriends = (type, name, link) => {
  const referralLink = `${handleReturnBaseUrl()}${link}`;
  const message = `Hi,\n\nI just saved 10 lives by becoming a member of Ketto's Social Impact Plan (SIP). Join hands with me to double our impact.\nIt is giving that gives back. When you join SIP with ₹100 or more, not only will you save lives every month, but you also get special access to Healthcare benefits for yourself.\n\nJoin now: ${encodeURI(referralLink)}\n\nLimited period offer.\n\nRegards,\n${capitalizeFirstLetter(name.split(' ')[0])}`;
  const device = handleGetOS();
  const whatsAppDomain = (device === 'Android' || device === 'iOS') ? 'api' : 'web';

  const domain = type === 'facebook' ? `https://www.facebook.com/sharer/sharer.php?&u=${referralLink}&quote=${encodeURIComponent(message)}` : `https://${whatsAppDomain}.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(domain, '_blank');
};

export const handleReturnBaseUrl = () => (process.env.NODE_ENV == 'development' ? 'https://dev1.ketto.org' : 'https://ketto.org');

export const capitalizeFirstLetter = (string) => string?.charAt(0)?.toUpperCase() + string?.slice(1);

export const handleGetOS = () => {
  // if (process.browser) {
  const { userAgent } = window.navigator;
  const { platform } = window.navigator;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }
  return os;
  // }
};

export const autoFocusOnErrorField = (validator) => {
  if (!validator.allValid()) {
    let count = 1;
    const formKeys = validator.fields;
    Object.keys(formKeys).map((x) => {
      if (!formKeys[x] && count < 2) {
        document.getElementsByName(x)[0].focus();
        count++;
      }
    });
    validator.showMessages();
  }
};

export const RedirectToSignIn = (flag = false) => {
  const url = document.location.href;
  window.location.href = handleKettoLinks(`new/signin?redirect_uri=${!flag ? url : url.replace('?', '&')}`, true);
};

// export const handleReturnRewardStatus = (action) => {
//   switch (action) {
//     case 1: return 'Activate';
//       break;
//     case 2: return 'Claim Now';
//       break;
//     case 3: return 'Reclaim Now'; // rejection case
//       break;
//     case 4: return 'Claimed';
//       break;
//     case 5: return 'Claim In Process';
//       break;
//     default: return '';
//       break;
//   }
// };

export const whatAppTemplate = (campaign, userId) => {
  let utmExist = null;
  const utmMedium = 'whatsappShare';
  if (userId) {
    utmExist = userId;
  } else if (getCookie('_ku')) {
    utmExist = getCookie('_ku');
  } else {
    utmExist = null;
  }

  const about_html = document.createElement('div');
  about_html.innerHTML = campaign && campaign.about && campaign.about.info_1;
  let about_text = about_html.textContent;
  about_text = about_text.replace(/\s\s+/g, ' ');
  const title = `Hey, \nI am supporting *${campaign.owner.full_name}’s* fundraiser on Ketto! Join me in supporting *${campaign.owner.fname}* by donating to their fundraiser on Ketto. \n\n`;
  const header = `*${campaign.owner.fname}’s fundraiser*  \n\n`;
  const subtitle = `*${campaign.title}* \n\n`;
  const Read_more = ` \n\n*Read More & Donate Now.* https://ketto.org/s?id=rm-${campaign.id}\nEven a small amount will make a difference. \n\nMany children are victims to deadly diseases like cancer and heart ailments. You have the power to save 12+ young lives by joining Ketto's Monthly Social Impact Plan. \n\n`;
  const Know_more = `Know more : https://www.ketto.org/new/sip?utm_medium=${utmMedium}&utm_content=${utmExist}&shby=1&utm_source=external_Ketto&utm_campaign=${campaign.custom_tag} \n\nThanks in advance.`;
  const mainMessage = title + header + subtitle + about_text.substr(0, 441).concat('...') + Read_more + Know_more;
  return mainMessage;
};

// export const ShortenLinks = (props) => {

//     if (props.link.length > 45) {
//         let shortLink;
//         shortLink = props.link.slice(0, 45);
//         return shortLink;
//     }
//     else {
//         return props.link;
//     }
// }

export const handlePopupCard = (isChecking, highlightValue) => {
  switch (isChecking) {
    case 'card1':
      return {
        highlight: highlightValue,
        highlightColor: '#444',
        description: 'Monthly Donors',
        descriptionColor: '',
        bgColor: '#FFE6D8',
        cardDescription: 'With the help of millions of donors like you, Ketto has been able to fund innumerable life-changing medical treatments, and bring a change in the lives of many.',
        cardDesc: 'Together, we have witnessed a community coming together to make healthcare accessible to all and make a difference in the world.',
        isOpen: true,
        cardType: 'card1',
      };
    case 'card2':
      return {
        highlight: highlightValue,
        highlightColor: '#404040',
        description: 'Kids Impacted',
        descriptionColor: '',
        bgColor2: '#B0D9FF',
        bgWidth: '100%',
        background: CoverImg,
        cardDescription: 'Many kids have been able to secure a more hopeful future with help from donations like yours. Our SIP Donors have displayed extreme compassion and empathy to help the less fortunate afford their medical bills.',
        isOpen: true,
        cardType: 'card2',
      };
    case 'card3':
      return {
        highlight: highlightValue,
        highlightColor: '#404040',
        description: 'Contributed',
        descriptionColor: '',
        bgColor: '#DDF6F7',
        cardDescription: 'Our mission of saving lives has been adopted by countless donors, and helped many urgent campaigns receive the funds they needed, in time.',
        cardDesc: 'We appreciate your valiant efforts into contributing and supporting the underprivileged with their medical emergencies. We at Ketto salute you for your promise to do good!',
        isOpen: true,
        cardType: 'card3',
      };
    case 'card4':
      return {
        highlight: highlightValue,
        highlightColor: 'white',
        description: 'CHANGEMAKERS',
        descriptionColor: '',
        bgColor2: '#8D91E2',
        bgColor1: '#8D91E2',
        bgWidth: '66%',
        background: MultiplecoverImg,
        cardDescription: 'Through collective, meticulous efforts from many donors like you, we have managed to fund over 540 life-saving treatments, and enabled many lives to dream of a hopeful tomorrow. We are glad you are along for the journey!',
        isOpen: true,
        cardType: 'card4',
      };
    default: return false;
  }
};

export const fetchSubscription = (res, multiId) => (res.length > 1 && multiId ? res.find((item) => item.id.toString() == multiId) : res[0]);

export const fetchSubscriptionAmount = (firstSub, currency) => {
  const currSymbol = firstSub ? firstSub?.currency?.toUpperCase() : currency?.toUpperCase();
  switch (currSymbol) {
    case 'INR':
      return firstAmountLogic(firstSub?.amount, 100, !firstSub, firstSub?.currency == 'inr');
    case 'USD':
    case 'GBP':
    case 'EUR':
    case 'CAD':
    case 'HKD':
    case 'QAR':
    case 'AUD':
    case 'MYR':
      return firstAmountLogic(firstSub?.amount, 10, !firstSub);
    case 'AED':
      return firstAmountLogic(firstSub?.amount, 20, !firstSub);
    case 'SGD':
      return firstAmountLogic(firstSub?.amount, 30, !firstSub);
    case 'SAR':
      return firstAmountLogic(firstSub?.amount, 50, !firstSub);
    default:
      return firstAmountLogic(firstSub?.amount, 100, !firstSub);
  }
};

export const firstAmountLogic = (newAmount, defaultAmount, checkNull, checkInr = false) => {
  if (checkNull) {
    return defaultAmount;
  }
  if (checkInr && !getCauseAmount()) {
    return newAmount < defaultAmount ? newAmount : defaultAmount;
  }
  if (getCauseAmount()) {
    return newAmount || defaultAmount;
  }
  return defaultAmount;
};

export const appCondition = (version = '1.0.4') => {
  const appVersion = getCookie('app_version');
  return (appVersion && appVersion.localeCompare(version, undefined, { numeric: true, sensitivity: 'base' }) !== -1);
};

export const isSipSelect = () => {
  const multiId = JSON.parse(sessionStorage.getItem('multiCauseId'));
  if (!multiId && !!((multiId && Object.entries(multiId).length === 0) || (!multiId?.id && !multiId?.cause))) {
    return true;
  }
  return false;
};

export const onBackSipSelect = (ename, pname, info1, info3, info2, ct) => {
  const multiSip = JSON.parse(localStorage.getItem('multiLength')) > 1;
  // eslint-disable-next-line no-unused-vars
  sendEvents(ename, pname, info1, info3, info2, ct).then((res) => {
    if (isSipSelect() && multiSip) {
      history.pushState({}, '', '/sipselect');
    }
  });
};

// Blitzllama trigger

export const blitzTrigger = (name) => window.blitz('triggerEvent', name);

export const handleMobShare = async (event, campaignData, isAppUser, handleClick) => {
  const user = localStorage.getItem('userdata') && JSON.parse(localStorage.getItem('userdata'));
  let utm_content = null;
  if (user && user.id) {
    utm_content = user.id;
  } else if (getCookie('_ku')) {
    utm_content = getCookie('_ku');
  } else {
    utm_content = null;
  }

  const shareData = {
    title: campaignData && campaignData.title,
    text: campaignData.owner.fname + ' wants to raise funds ' + campaignData.title + '. Your donation has the power to help them move closer to their goal amount. Please contribute',
    url: handleKettoLinks(`fundraiser/${campaignData.custom_tag}?utm_medium=nativeShare&utm_content=${utm_content}&shby=1&utm_source=external_impact_calling&utm_campaign=${campaignData.custom_tag}`),
  };
  console.log(`tech share~${shareData.title}~${shareData.text}~${shareData.url}`);
  if (!isAppUser) {
    if (navigator.share) {
      navigator.share(shareData).then(() => {
        console.log('Thanks for sharing!');
      })
        .catch((err) => {
          console.log('Couldn\'t share because of', err.message);
        });
    } else {
      handleClick(event, true);
      console.log('web share not supported');
    }
  }
};

export const dateFromNowFormat = (displayDate) => {
  const spaceRemoved = displayDate && displayDate.replace(' ', '').slice(0, 2);
  return spaceRemoved >= 10 ? displayDate.replace(' ', '').slice(0, 3) : spaceRemoved;
};

export const dateTimeZone = (date) => {
  const oldDateObj = dayjs(date).toDate();
  const newDateObj = new Date();
  return newDateObj.setTime(oldDateObj.getTime() + (330 * 60 * 1000));
};

export const countDeedsTask = (response) => {
  const taskList = response?.data?.data?.donor_deeds_info;
  let count = 0;
  taskList.forEach((item) => {
    if (item.status) count++;
  });
  return count;
};

// frequency
export const checkFrequency = (frequency) => {
  if (typeof frequency !== 'string') {
    return 0;
  }
  if (frequency.includes('month')) {
    if (frequency === '1 months') {
      return 'every month';
    }
    return `/${frequency}`;
  }
  if (frequency.includes('day')) {
    return `/${frequency}`;
  }
  if (frequency.includes('week')) {
    return `/${frequency}`;
  }
  return 0;
};

export const checkFrequencyEvery = (frequency) => {
  if (typeof frequency !== 'string') {
    return 0;
  }
  if (frequency.includes('month')) {
    if (frequency === '1 months') {
      return 'every month';
    }
    return `every ${frequency}`;
  }
  if (frequency == "1") {
    return `every month`;
  }
  if (frequency.includes('day')) {
    return `every ${frequency}`;
  }
  if (frequency.includes('week')) {
    return `every ${frequency}`;
  }
  return 0;
};

export const checkNonSip = (response) => response && (response.length == 0 || (Object.keys(response).length == 1 && ('memorial' in response))) && !!getCookie('platform');

export const checkSipSubscribed = (response) => {
  if (response && Object.keys(response).length > 0) {
    if (response && ('memorial' in response) && Object.keys(response).length == 1) { // for non-sip user
      return false;
    }
    return true;
  }
  return false;
};

export const filterNotSubscribedSip = (cause) => {
  const multiArray = JSON.parse(localStorage.getItem('multiArray'));
  const filteredNew = multiArray && multiArray.filter((item) => item.label == 'NEW');
  return filteredNew && filteredNew.length != 0 && filteredNew.find((item) => item.campaign_cause == cause);
};

export const pitchInfoCause = (cause) => {
  const isSwitch = getUrlParameterByName('switch');
  const isInfo = getUrlParameterByName('info3');
  const isMySip = getUrlParameterByName('fromMysip');
  const cartInfo = getUrlParameterByName('cartInfo');
  if (cartInfo) {
    return `${cause}_cart`;
  }
  if (isSwitch) {
    return `${cause}_switch${isMySip ? '_mysip' : ''}`;
  }
  if (isInfo) {
    return `${cause}_${isInfo}`;
  }
  return cause;
};

export const makeOnDemandSubs = (id, causeName, amount, currency, subId) => new Promise((resolve) => {
  const isABName = getABName();
  const newSipParam = sipParamUrl(causeName, amount);
  const sipCauseParam = [];
  causeName.forEach((item) => {
    sipCauseParam.push({ cause: item });
  });
  const reqData = {
    amount: parseInt(amount),
    currency,
    sip_cause: sipCauseParam,
  };
  if (subId) {
    reqData.subscription_id = subId;
  }
  onDemandSubscription(id, reqData).then((res) => {
    const campaignData = res.data && Object.values(res.data) && Object.values(res.data) != 0 && Object.values(res.data)[0];
    const sipParams = Object.values(res.data) != 0 && Object.keys(res.data).map((value) => `sip_cause=${value}`).join('&');
    resolve(true);
    if (causeName == 'insurance') {
      window.location.href = handleKettoLinks(`new/thankyou?id=${campaignData?.campaign_id}&or=sps&${sipParams}&oi=${campaignData?.order_detail_id}&plan=${amount == '50' ? 'care' : 'plus'}`);
    } else {
      window.location.href = handleKettoLinks(`new/thankyou?id=${campaignData?.campaign_id}&or=siptc&sip_cause=${newSipParam}&oi=${campaignData?.order_detail_id}${isABName}&ref_or=retention`);
    }
  }).catch((err) => { resolve(false); toast.error(err.data.message, { theme: 'colored', autoClose: 3000, position: 'top-right' }); });
});

export const OnDemandSubsSwitch = (id, fromCause, causeName, fromId, subId) => new Promise((resolve, reject) => {
  const reqData = {
    switch_cause: 'true',
    from_cause: fromCause,
    from_subs_id: fromId,
    subscription_id: subId,
    sip_cause: causeName,
  };

  onDemandSubscription(id, reqData).then((res) => {
    resolve(true);
    console.log(res);
  }).catch((err) => { toast.error(err.data.message, { theme: 'colored', autoClose: 3000, position: 'top-right' }); });
});

export const checkMultiSip = () => {
  const multiArray = JSON.parse(localStorage.getItem('multiArray'));
  const isNewSip = multiArray && multiArray.length != 0 && multiArray.find((item) => item.label == 'NEW');
  return isNewSip && isNewSip.length != 0;
};

export const checkCampaignType = (id) => {
  switch (id) {
    case 20:
      return 'personal';
    case 48:
      return 'ngo';
    case 49:
      return 'creative';
    case 149:
      return 'ad';
    default:
      return '';
  }
};

export const latestApiParams = (subData, multiCause) => {
  const medicalSip = multiCause && multiCause.find((res1) => res1.campaign_cause == 'medical');
  const checkWindow = window.location.pathname == '/allocatefunds';
  const obj = {
    id: !checkWindow ? subData && subData.id : medicalSip && medicalSip.id,
    cause: !checkWindow ? subData && subData.campaign_cause : 'medical',
  };
  return obj;
};

// eslint-disable-next-line no-unused-vars
export const onPortFolioUpdate = (multiArray, causeId) => new Promise((resolve, reject) => {
  const selectedSip = multiArray && multiArray.find((item) => item.label != 'NEW') && multiArray.find((item) => item.id == causeId);
  const latestParam = latestApiParams(selectedSip, multiArray);
  getPortfolio(latestParam && latestParam.id, latestParam && latestParam.cause, {}).then((res) => {
    resolve(res);
  });
});

export const getABName = () => {
  const ab_item = JSON.parse(sessionStorage.getItem('ab_item'));
  const abtestname = ab_item && ab_item?.abtestname;
  const abvalue = ab_item && ab_item?.abvalue;
  return abtestname && abvalue ? `&abtestname=${abtestname}&abvalue=${abvalue}` : '';
};

export const getUTMSource = () => {
  const params = getUrlParams();
  const checkCookie = getDecodedCookies('k_utm');
  if ('utm_source' in params || 'utm_medium' in params || 'utm_campaign' in params || (checkCookie && !isObjEmpty(checkCookie))) {
    const source = getUTMParameters('utm_source') && getUTMParameters('utm_source') != 'null' ? `&utm_source=${getUTMParameters('utm_source')}` : '';
    const medium = getUTMParameters('utm_medium') && getUTMParameters('utm_medium') != 'null' ? `&utm_medium=${getUTMParameters('utm_medium')}` : '';
    const campaign = getUTMParameters('utm_campaign') && getUTMParameters('utm_campaign') != 'null' ? `&utm_campaign=${getUTMParameters('utm_campaign')}` : '';
    return `${source}${medium}${campaign}`;
  }
  return false;
};

export const fetchSubscriptionCurrency = (latestOrder, userData) => (latestOrder?.ondemandSubscription ? latestOrder?.ondemandSubscription?.currency.toUpperCase() : userData?.latest_subscription?.currency.toUpperCase());

export const isObjEmpty = (data) => Object.keys(data)?.length == 0;

// export const containRewards = (data) => !Object.keys(data).every((key) => data[key].length === 0);

export const getUserClevertapData = (data) => {
  const clevertapData = {
    Site: {
      Identity: data?.id,
      Email: data?.email,
      Name: data?.full_name,
      Phone: data?.phone_1,
      Mobile: data?.phone_1,
    },
  };
  return clevertapData;
};

export const isAllSipSubscribed = (multiArray) => multiArray && multiArray.every((item) => item.label !== 'NEW');

export const getUTMParameters = (param) => {
  const checkUrl = getUrlParams();
  const checkCookie = getDecodedCookies('k_utm');
  return (checkUrl && !isObjEmpty(checkUrl) && (param in checkUrl) ? checkUrl[param] : (checkCookie && !isObjEmpty(checkCookie) && (param in checkCookie)) ? checkCookie[param] : '');
};

export const removeDuplicateParams = (url) => {
  const [baseUrl, queryString] = url.split('?');

  if (!queryString) {
    return url;
  }

  const params = [];

  queryString.split('&').forEach((param) => {
    const [paramName, paramValue] = param.split('=');

    // Check if the parameter already exists in the array
    const exists = params.some((p) => {
      const [existingName, existingValue] = p.split('=');
      return existingName === paramName && existingValue === paramValue;
    });

    // Add the parameter only if it doesn't already exist
    if (!exists) {
      params.push(param);
    }
  });

  const resultQueryString = params.join('&');

  return `${baseUrl}?${resultQueryString}`;
};

export const unSubscribedSips = (multiArray) => multiArray.filter((item) => item.label == 'NEW');

export const setCauseCart = (multiArray, causeName) => {
  if (!getCookie('platform')) {
    const cartSIP = multiArray?.length != 0 && (multiArray).find((item) => item.campaign_cause == causeName);
    localStorage.setItem('cartCause', JSON.stringify(cartSIP));
  }
};

export const showBundleCauses = (multiArray, causeName, userData) => {
  const unSubscribedSip = multiArray?.length != 0 && multiArray.filter((item) => item.label == 'NEW');
  const isInr = userData?.latest_subscription?.currency?.toLowerCase() == 'inr';
  return getUrlParameterByName('bundleCause') && unSubscribedSip?.length != 0 && unSubscribedSip.find((item) => item.campaign_cause != causeName) && isInr && getBundleCauses();
};

// export const getRewardStatus = (data, history) => {
//   const rewardName = getUrlParameterByName('name');
//   const rewardData = data && data?.standard && data?.standard.find((item) => item.name == rewardName);
//   if (rewardData) {
//     return rewardData && rewardData.action == 1;
//   }
//   return 'redirect';
// };

export const domSanitizer = (dirty) => {
  const clean = DOMPurify.sanitize(dirty);
  return clean || dirty;
}

export const sipParamUrl = (multiCauses, firstAmount) => (multiCauses.length > 1 ? JSON.stringify(multiCauses.map((value) => ({ sip_cause: value, amount: firstAmount }))) : multiCauses[0]);

export const isValidDate = (dateString, format = 'DD/MM/YYYY') => dayjs(dateString, format, true).isValid();

export const areIdenticalArrays = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const frequencyMap = {};

  for (let i = 0; i < arr1.length; i++) {
    const elem = arr1[i];
    if (frequencyMap[elem] === undefined) {
      frequencyMap[elem] = 1;
    } else {
      frequencyMap[elem]++;
    }
  }

  for (let i = 0; i < arr2.length; i++) {
    const elem = arr2[i];
    if (frequencyMap[elem] === undefined) {
      return false;
    }
    frequencyMap[elem]--;
    if (frequencyMap[elem] < 0) {
      return false;
    }
  }

  return true;
};

export const doubleDigitNum = (num) => (num).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });

export const getOrdinalSuffix = (n) => {
  const s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
}
